module.exports = __webpack_public_path__ + "img/cart-buy-hen.f0a1c779.png";